module.exports = __webpack_public_path__ + "static/16-1c761010c33a6516b44ba8ce2c87680e.jpg";